/* @ts-ignore */
import * as Types from '../../../graphql/generated/graphql.g';

import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';

function fetcher<TData, TVariables>(query: string, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(import.meta.env.VITE_API_URL_GRAPHQL as string, {
    method: "POST",
    ...({"credentials":"include","headers":{"Content-Type":"application/json"}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type ApplicationTotalUsersStatQueryVariables = Types.Exact<{
  applicationId: Types.Scalars['UUID']['input'];
  clientId: Types.Scalars['UUID']['input'];
}>;


export type ApplicationTotalUsersStatQuery = { __typename: 'Query', clientApplication?: { __typename: 'ClientApplicationType', id: string, employees?: { __typename: 'ClientEmployeeTypeConnection', totalCount?: number | null } | null } | null };



export const ApplicationTotalUsersStatDocument = `
    query ApplicationTotalUsersStat($applicationId: UUID!, $clientId: UUID!) {
  clientApplication(id: $applicationId, clientId: $clientId) {
    id
    employees {
      totalCount
    }
  }
}
    `;

export const useApplicationTotalUsersStatQuery = <
      TData = ApplicationTotalUsersStatQuery,
      TError = unknown
    >(
      variables: ApplicationTotalUsersStatQueryVariables,
      options?: Omit<UseQueryOptions<ApplicationTotalUsersStatQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApplicationTotalUsersStatQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApplicationTotalUsersStatQuery, TError, TData>(
      {
    queryKey: ['ApplicationTotalUsersStat', variables],
    queryFn: fetcher<ApplicationTotalUsersStatQuery, ApplicationTotalUsersStatQueryVariables>(ApplicationTotalUsersStatDocument, variables),
    ...options
  }
    )};

useApplicationTotalUsersStatQuery.getKey = (variables: ApplicationTotalUsersStatQueryVariables) => ['ApplicationTotalUsersStat', variables];

export const useInfiniteApplicationTotalUsersStatQuery = <
      TData = InfiniteData<ApplicationTotalUsersStatQuery>,
      TError = unknown
    >(
      variables: ApplicationTotalUsersStatQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ApplicationTotalUsersStatQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApplicationTotalUsersStatQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ApplicationTotalUsersStatQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ApplicationTotalUsersStat.infinite', variables],
      queryFn: (metaData) => fetcher<ApplicationTotalUsersStatQuery, ApplicationTotalUsersStatQueryVariables>(ApplicationTotalUsersStatDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteApplicationTotalUsersStatQuery.getKey = (variables: ApplicationTotalUsersStatQueryVariables) => ['ApplicationTotalUsersStat.infinite', variables];


useApplicationTotalUsersStatQuery.fetcher = (variables: ApplicationTotalUsersStatQueryVariables) => fetcher<ApplicationTotalUsersStatQuery, ApplicationTotalUsersStatQueryVariables>(ApplicationTotalUsersStatDocument, variables);
